import React from 'react'
import './nav-top.css'

export default function Nav(props) {
  return (
    <>
    <nav className='nav-bar-top'>
      <div className='header-box'>
        <h1>Linus</h1>
      </div>
    </nav>
    </>
  )
}